import api from "../api";

/**
 * Add coupons for a user.
 *
 * @param {string} userId - The ID of the user.
 * @param {Object} newCoupon - The list of new coupons to be added.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails, userId is not provided, or newCoupons array is empty.
 */
const addCoupon = async (userId, newCoupon) => {
  if (!userId) {
    throw new Error('User ID is required.');
  }

  if (!newCoupon ) {
    throw new Error('At least one new coupon is required.');
  }

  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/user/addCoupon`;
  const requestBody = {
    user_id:userId,
    new_coupon: newCoupon
  };

  try {

    const response = await api.post(endpoint, requestBody);
    return response.data;
  } catch (error) {
    console.error(`Error while adding coupons for user ${userId}:`, error);
    throw error;
  }
}

export default addCoupon;
